var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubCardIcon = function SvgSubCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13c0-.552-.47-1-1.051-1H7.692V6h3.59L7.383 2.293a1.09 1.09 0 0 0-1.487 0L2 6h3.59v7c0 .552.47 1 1.05 1h6.309c.58 0 1.051-.448 1.051-1Z",
    fill: "#262D38",
    fillOpacity: 0.3
  })));
};
export default SvgSubCardIcon;